var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/FileFilter.ts
import { onlyServer } from "@adornis/base/decorators/onlyServer.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisFilter } from "@adornis/filter/AdornisFilter.js";
import { FileListItem } from "./FileListItem.js";
import { FileTag } from "./FileTag.js";
var FileFilter = class extends AdornisFilter {
  getAdditionalFileListAggregation() {
    return [];
  }
  getFileListAggregation({ skip, limit, gqlFields, resolvedFileClasses }) {
    return [
      ...resolvedFileClasses.map((fileClass) => {
        return {
          $unionWith: {
            coll: fileClass._collectionName
          }
        };
      }),
      {
        $group: {
          _id: "$_id",
          doc: { $first: "$$ROOT" }
        }
      },
      {
        $replaceRoot: { newRoot: "$doc" }
      },
      {
        $project: {
          _class: FileListItem._class,
          file: "$$ROOT"
        }
      },
      {
        $lookup: {
          from: FileTag._collectionName,
          localField: "_id",
          foreignField: "fileID",
          as: "tags"
        }
      },
      // * an dem Punkt können die Daten nochmal verändert/erweitert werden
      ...this.getAdditionalFileListAggregation(),
      {
        $match: {
          "file._class": {
            $in: this.fileClassNames ?? []
          },
          ...this.fileExtensions?.length ? {
            $expr: {
              $in: [{ $toLower: "$file.meta.extension" }, this.fileExtensions.map((ext) => ext.toLowerCase())]
            }
          } : {},
          ...this.fileName ? {
            $or: [
              {
                "file.meta.fileName": {
                  $regex: `${this.fileName}`,
                  $options: "i"
                }
              },
              // Nach Dateinamen filtern
              {
                "tags.tagName": {
                  $regex: `${this.fileName}`,
                  $options: "i"
                }
              }
              // Nach Tags filtern
            ]
          } : {},
          ...this.isWithoutTags ? {
            $expr: { $eq: [{ $size: "$tags" }, 0] }
          } : {}
        }
      },
      {
        $project: gqlFields
      },
      {
        $sort: {
          "file.createdAt": -1
        }
      },
      { $skip: skip },
      { $limit: limit }
    ];
  }
};
FileFilter._class = "FileFilter";
__decorateClass([
  Field((type) => String)
], FileFilter.prototype, "fileName", 2);
__decorateClass([
  Field((type) => [String])
], FileFilter.prototype, "fileExtensions", 2);
__decorateClass([
  Field((type) => [String])
], FileFilter.prototype, "fileClassNames", 2);
__decorateClass([
  Field((type) => Boolean)
], FileFilter.prototype, "isWithoutTags", 2);
__decorateClass([
  onlyServer
], FileFilter.prototype, "getAdditionalFileListAggregation", 1);
__decorateClass([
  onlyServer
], FileFilter.prototype, "getFileListAggregation", 1);
FileFilter = __decorateClass([
  Entity()
], FileFilter);
export {
  FileFilter
};
